export const ClaimStatus = {
  UPCOMING : "Upcoming",
  ONGOING : "On-going",
  DORMANT : "Dormant",
  COMPLETED : "Completed",
  REOPENED : "Re-opened",
  REJECTED : "Rejected",
  INVALID : "Invalid",
}